<template>
  <div
    style="
      width: 100%;
      height: auto;
      display: flex;
      justify-content: center;
      margin-top: 32px;
    "
  >
    <div
      style="
        width: 1200px;
        height: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-bottom: 100px;
		padding-top: 30px;
      "
    >
      <div style="width: 800px; height: 58px; margin: 30px 0; display: flex">
        <a-select
          style="width: 120px"
          v-model="selectedValue"
          placeholder="请选择"
          @change="handleSelectChange"
        >
          <a-select-option
            v-for="item in options"
            :key="item.value"
            :value="item.value"
          >
            {{ item.label }}
          </a-select-option>
        </a-select>
        <div
          style="
            width: 680px;
            height: 100%;
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
            position: relative;
          "
        >
          <a-input
            v-model="keyword"
            @pressEnter="searchBtn"
            style="width: 100%; height: 100%; border-radius: 0"
            :placeholder="$t('h.custom.EnterTheContentYouNeedToSearch')"
          />
          <img
            style="
              width: 26px;
              height: 26px;
              position: absolute;
              right: 16px;
              top: 16px;
              cursor: pointer;
            "
            src="@/assets/img/suppliersearch.png"
            @click="searchBtn"
          />
        </div>
      </div>
      <div style="width: 100%; display: flex">
        <!--        height: 649px;-->
        <div style="width: 302px; margin-right: 20px; display: flex; flex-direction: column; gap: 16px;">
          <div v-if="hotTags.length > 0" class="filter-card">
            <div class="filter-header">
              <div class="filter-title">
                <span class="title-icon">★</span>
                <h3>{{ $t('h.ProductSupplier.PopularCategories') }}</h3>
              </div>
              <a-button 
                v-if="selectedTags.length > 0 || selectedHalls.length > 0 || isOnlineExhibitor"
                @click="resetFilters" 
                class="reset-btn"
              >
                {{ $t('h.custom.Reset') }}
              </a-button>
            </div>
            <div class="filter-content">
              <span
                  v-for="(tag, index) in hotTags"
                  :key="index"
                  @click="handleCategoryClick(tag)"
                  :class="['filter-tag', { active: selectedTags.includes(tag.code) }]"
              >
                {{ tag.name }} 
              </span>
            </div>
          </div>
          
          <div class="filter-card">
            <div class="filter-header">
              <div class="filter-title">
                <span class="title-icon">📍</span>
                <h3>{{ $t('h.ProductSupplier.SearchByHall') }}</h3>
              </div>
              <a-button 
                v-if="selectedTags.length > 0 || selectedHalls.length > 0 || isOnlineExhibitor"
                @click="resetFilters" 
                class="reset-btn"
              >
                {{ $t('h.custom.Reset') }}
              </a-button>
            </div>
            <div class="filter-content">
              <span
                  v-for="(hall, index) in exhibitionHalls"
                  :key="index"
                  @click="handleHallSelect(hall)"
                  :class="['filter-tag', { active: selectedHalls.includes(hall) }]"
              >
                {{ hall }} 
              </span>
              <span
                  @click="handleOnlineExhibitorSelect"
                  :class="['filter-tag', { active: isOnlineExhibitor }]"
              >
                {{ $language === 'ZH' ? '在线展商' : 'Online Exhibitor' }}
              </span>
            </div>
          </div>

          <!--<img
            style="width: 100%; min-height: 800px; border-radius: 4px"
            :src="coverImage"
          />-->
          <!--          <img style="width: 100%;min-height: 800px;border-radius: 4px;" src="@/assets/img/supplierpeitu.png"/>-->
        </div>
        <div style="width: 878px; min-height: 649px">
          <div style="width: 100%; background: #fafafa">
            <a-button-group>
              <a-button
                @click="tabChange(1)"
                :style="
                  current === 1
                    ? 'background: #d7000F;color: #FFFFFF;'
                    : 'background: #E9EEF6;color: #444444;'
                "
                style="
                  border: none;
                  width: 210px;
                  height: 42px;
                  font-family: PingFangSC-Medium;
                  font-size: 15px;
                "
              >
                {{ $t("h.ProductSupplier.ProductList") }}（{{
                  productDataPage.total
                }}）
              </a-button>
              <a-button
                @click="tabChange(2)"
                :style="
                  current === 2
                    ? 'background: #d7000F;color: #FFFFFF;'
                    : 'background: #E9EEF6;color: #444444;'
                "
                style="
                  border: none;
                  width: 210px;
                  height: 42px;
                  font-family: PingFangSC-Medium;
                  font-size: 15px;
                "
              >
                {{ $t("h.ProductSupplier.SupplierList") }}（{{
                  supplierDataPage.total
                }}）
              </a-button>
              <a-button
                @click="tabChange(3)"
                :style="
                  current === 3
                    ? 'background: #d7000F;color: #FFFFFF;'
                    : 'background: #E9EEF6;color: #444444;'
                "
                style="
                  border: none;
                  width: 210px;
                  height: 42px;
                  font-family: PingFangSC-Medium;
                  font-size: 15px;
                "
              >
                {{ $language === 'ZH' ? '在线展商' : 'Online Exhibitor' }}（{{
                  onlineSupplierDataPage.total
                }}）
              </a-button>
            </a-button-group>
          </div>
          <div v-if="current === 3">
            <div
              v-for="(item, index) in onlineSupplierData"
              :key="index"
              @click="supplierDetailBtn(item.id)"
              class="list-card"
            >
              <div class="card-header">
                <div class="card-title">
                  {{
                    getTextByLanguage(
                      item[$language === "ZH" ? "companyNameCn" : "companyNameEn"],
                      item[$language === "ZH" ? "companyNameEn" : "companyNameCn"]
                    )
                  }}
                  <span
                    v-if="getCxifLabel(item.cxif)"
                    class="cxif-badge"
                  >
                    {{ getCxifLabel(item.cxif) }}
                  </span>
                </div>
              </div>
              <div class="card-content">
                <div class="card-description">
                  {{
                    getTextByLanguage(
                      item[$language === "ZH" ? "companyDescriptionCn" : "companyDescriptionEn"],
                      item[$language === "ZH" ? "companyDescriptionEn" : "companyDescriptionCn"]
                    )
                  }}
                </div>
                <div class="card-tags">
                  <span v-if="item.classifyName"
                        @click.stop="handleClassifySearch(item.classify)"
                        class="card-tag">
                        {{ item.classifyName }}
                  </span>
                </div>
                <div class="card-footer">
                  <div class="booth-info" v-if="item.boothNumber">
                    <img
                      src="@/assets/img/dingwei.png"
                    />
                    <span style="font-size: 13px; color: #5a6c7d;">{{ item.boothNumber }}</span>
                  </div>
                  <div class="card-actions">
                    <a-button
                      @click.stop="consultBtn(item.id)"
                      class="action-btn"
                    >
                      <img
                        style="width: 22px; height: 22px"
                        src="@/assets/img/zixun.png"
                      />
                      <span>{{ $t("h.ProductSupplier.Consult") }}</span>
                    </a-button>
                    <a-button
                      class="action-btn"
                      @click.stop="handleShare('供应商', item.id)"
                    >
                      <img
                        style="width: 22px; height: 22px"
                        src="@/assets/img/fenxiang.png"
                      />
                      <span>{{ $t("h.ProductSupplier.Share") }}</span>
                    </a-button>
                    <a-button
                      class="action-btn"
                      @click.stop="handleAddCollection(item)"
                    >
                      <img
                        style="width: 22px; height: 21px"
                        :src="item.isCollect ? iconStar : shoucang3"
                      />
                      <span>{{
                          item.isCollect
                            ? $t("h.ProductSupplier.Collected")
                            : $t("h.ProductSupplier.Collect")
                        }}</span>
                    </a-button>
                  </div>
                </div>
              </div>
            </div>
            <div style="text-align: center; margin: 20px 0">
              <a-pagination
                v-model="onlineSupplierDataPage.pageNo"
                :pageSize="onlineSupplierDataPage.pageSize"
                :total="onlineSupplierDataPage.total"
                show-less-items
                class="myPagination"
                hideOnSinglePage
                @change="handleOnlineSupplierPageChange"
              />
            </div>
          </div>
          <div v-else-if="current === 2">
            <div
              v-for="(item, index) in supplierData"
              :key="index"
              @click="supplierDetailBtn(item.id)"
              class="list-card"
            >
              <div class="card-header">
                <div class="card-title">
                  {{
                    getTextByLanguage(
                      item[$language === "ZH" ? "companyNameCn" : "companyNameEn"],
                      item[$language === "ZH" ? "companyNameEn" : "companyNameCn"]
                    )
                  }}
                  <span
                    v-if="getCxifLabel(item.cxif)"
                    class="cxif-badge"
                  >
                    {{ getCxifLabel(item.cxif) }}
                  </span>
                </div>
              </div>
              <div class="card-content">
                <div class="card-description">
                  {{
                    getTextByLanguage(
                      item[$language === "ZH" ? "companyDescriptionCn" : "companyDescriptionEn"],
                      item[$language === "ZH" ? "companyDescriptionEn" : "companyDescriptionCn"]
                    )
                  }}
                </div>
                <div class="card-tags">
                  <template v-if="item.tags">
                      <span v-for="(tag, index) in item.tags.split(',')" :key="index"
                      @click.stop="handleTagSearch(tag)" class="card-tag">
                      {{ $language === 'ZH' ? tag.name : tag.nameEn }}
                       </span>
                  </template>

                  <span v-if="item.classifyName"
                        @click.stop="handleClassifySearch(item.classify)"
                        class="card-tag">
                        {{ item.classifyName }}
                  </span>
                </div>
                <div class="card-footer">
                  <div class="booth-info">
                    <img
                      src="@/assets/img/dingwei.png"
                    />
                    <a href="javascript:;">{{ item.boothNumber }}</a>
                  </div>
                  <div class="card-actions">
                    <a-button
                      @click.stop="consultBtn(item.id)"
                      class="action-btn"
                    >
                      <img
                        style="width: 22px; height: 22px"
                        src="@/assets/img/zixun.png"
                      />
                      <span>{{ $t("h.ProductSupplier.Consult") }}</span>
                    </a-button>
                    <a-button
                      class="action-btn"
                      @click.stop="handleShare('供应商', item.id)"
                    >
                      <img
                        style="width: 22px; height: 22px"
                        src="@/assets/img/fenxiang.png"
                      />
                      <span>{{ $t("h.ProductSupplier.Share") }}</span>
                    </a-button>
                    <a-button
                      class="action-btn"
                      @click.stop="handleAddCollection(item)"
                    >
                      <img
                        style="width: 22px; height: 21px"
                        :src="item.isCollect ? iconStar : shoucang3"
                      />
                      <span>{{
                          item.isCollect
                            ? $t("h.ProductSupplier.Collected")
                            : $t("h.ProductSupplier.Collect")
                        }}</span>
                    </a-button>
                  </div>
                </div>
              </div>
            </div>
            <div style="text-align: center; margin: 20px 0">
              <a-pagination
                v-model="supplierDataPage.pageNo"
                :pageSize="supplierDataPage.pageSize"
                :total="supplierDataPage.total"
                show-less-items
                class="myPagination"
                hideOnSinglePage
                @change="handleSupplierPageChange"
              />
            </div>
          </div>
          <div v-else>
            <div
              v-for="(item, index) in productData"
              :key="index"
              @click="productDetailBtn(item.id)"
              class="list-card product-card"
            >
              <div class="card-header">
                <div class="card-title">
                  {{ getTextByLanguage(item[$language === "ZH" ? "titleCn" : "titleEn"], item[$language === "ZH" ? "titleEn" : "titleCn"]) }}
                </div>
              </div>
              <div class="card-content product-content">
                <img
                  class="product-image"
                  :src="item.imageUrl"
                />
                <div class="product-right-section">
                  <div class="product-info">
                    <div class="card-description product-desc">
                      {{
                        getTextByLanguage(
                          $language === "ZH" ? (item.briefCn || item.descriptionCn) : (item.briefEn || item.descriptionEn),
                          $language === "ZH" ? (item.briefEn || item.descriptionEn) : (item.briefCn || item.descriptionCn)
                        )
                      }}
                    </div>
                    <div class="card-tags">
                      <template v-if="item.tags">
                        <span
                          v-for="(tag, index) in item.tags.split(',')"
                          :key="index"
                          @click.stop="handleTagSearch(tag)"
                          class="card-tag"
                        >
                          {{ item }}</span
                        >
                      </template>
                    </div>
                    <div class="company-name" v-if="item.companyProfiles">
                      {{
                        item.companyProfiles
                          ? getTextByLanguage(
                              item.companyProfiles[$language === "ZH" ? "companyNameCn" : "companyNameEn"],
                              item.companyProfiles[$language === "ZH" ? "companyNameEn" : "companyNameCn"]
                            )
                          : ""
                      }}
                    </div>
                    <div class="booth-info" v-if="item.companyProfiles">
                      <img src="@/assets/img/dingwei.png" />
                      <a href="javascript:;">{{
                          item.companyProfiles
                            ? item.companyProfiles.boothNumber
                            : ""
                        }}</a
                      >
                    </div>
                  </div>
                  <div class="card-actions">
                    <a-button
                      @click.stop="consultBtn(item.id)"
                      class="action-btn"
                    >
                      <img
                        style="width: 22px; height: 22px"
                        src="@/assets/img/zixun.png"
                      />
                      <span>{{ $t("h.ProductSupplier.Consult") }}</span>
                    </a-button>
                    <a-button
                      class="action-btn"
                      @click.stop="handleShare('产品', item.id)">
                    <img
                      style="width: 22px; height: 22px"
                      src="@/assets/img/fenxiang.png"
                    />
                    <span>{{ $t("h.ProductSupplier.Share") }}</span>
                    </a-button>
                    <a-button
                      class="action-btn"
                      @click.stop="handleAddCollection(item)">
                    <img
                      style="width: 22px; height: 21px"
                      :src="item.isCollect ? iconStar : shoucang3"
                    />
                    <span>{{
                        item.isCollect
                          ? $t("h.ProductSupplier.Collected")
                          : $t("h.ProductSupplier.Collect")
                      }}</span>
                    </a-button>
                  </div>
                </div>
              </div>
            </div>
            <div style="text-align: center; margin: 20px 0">
              <a-pagination
                v-model="productDataPage.pageNo"
                :pageSize="productDataPage.pageSize"
                :total="productDataPage.total"
                show-less-items
                class="myPagination"
                hideOnSinglePage
                @change="handleProductPageChange"
              />
            </div>
          </div>
        </div>
      </div>

      <!--      <div style="width: 100%;padding: 100px 0;display: flex;justify-content: center;">
              <a-button class="customBtn"
                        style="border: none;width: 420px;height: 48px;background: #d7000F;border-radius: 1px;font-size: 16px;color: #FFFFFF;">
                登录到观众中心约展商见面
              </a-button>
            </div>-->

      <a-modal
        :title="$t('h.ProductSupplier.Consult')"
        :visible="consultDialogOpen"
        :closable="false"
      >
        <a-textarea
          v-model="inviteContent"
          :placeholder="
            $t('h.ProductSupplier.PleaseEnterTheContentYouWantToConsult')
          "
          :auto-size="{ minRows: 5 }"
          max-length="200"
        />
        <div
          style="
            font-size: 12px;
            color: #d7000F;
            display: flex;
            align-items: center;
            height: 30px;
          "
        >
          {{ $t("h.ProductSupplier.MaximumInput") }}
        </div>
        <template slot="footer">
          <a-button
            key="submit"
            type="danger"
            @click="submitBtn"
            :loading="loading"
          >
            {{ $t("h.custom.ConfirmSubmission") }}
          </a-button>
          <a-button @click="consultDialogOpen = false" key="back">
            {{ $t("h.custom.Cancel") }}
          </a-button>
        </template>
      </a-modal>
    </div>
  </div>
</template>

<script>
import {
  addCollection,
  addConsultations,
  getCompanyProfilesList,
  getEntriesList,
} from "@/assets/api";
import { codeConfig } from "../../../assets/api";

import shoucang3 from "@/assets/img/shoucang3.png";
import iconStar from "@/assets/img/icon-star.png";

export default {
  name: "Supplier",
  data() {
    return {
      shoucang3,
      iconStar,
      current: 0,
      keyword: null,
      selectedValue: "供应商",
      searchType: null, // 新增搜索类型
      options: [
        {
          label: this.$t("h.ProductSupplier.Supplier"),
          value: "供应商",
        },
        {
          label: this.$t("h.ProductSupplier.Product"),
          value: "产品",
        },
        {
          label: this.$language === 'ZH' ? '在线展商' : 'Online Exhibitor',
          value: "在线展商",
        },
        // {
		    //   label: this.$t("h.ProductSupplier.booth"),
		    //   value: "展位号",
		    // },
      ],
      supplierData: [
        /*{
          title: '快思蕊科技（上海）有限公司',
          content: '快思蕊科技（上海）有限公司是新材料领域的未来独角兽企业Crerax长期致力于高分子材料新领域的探索和研发，孵化了可膨胀微球孵化了可膨胀微球、涂料、超轻黏土、GMT、解决方案专家等构成的创新生态圈。通过多年的自主研发创新，Crerax产品、技术与服务已与国际巨头比肩，在全球超过25个国家帮助客户升级产品，服务航空航天、汽车、建筑、印染等120多个行业,为明日生活“创造无限可能”。',
          address: '6.2A51',
          collect: false
        },
        {
          title: '快思蕊科技（上海）有限公司',
          content: '快思蕊科技（上海）有限公司是新材料领域的未来独角兽企业Crerax长期致力于高分子材料新领域的探索和研发，孵化了可膨胀微球孵化了可膨胀微球、涂料、超轻黏土、GMT、解决方案专家等构成的创新生态圈。通过多年的自主研发创新，Crerax产品、技术与服务已与国际巨头比肩，在全球超过25个国家帮助客户升级产品，服务航空航天、汽车、建筑、印染等120多个行业,为明日生活“创造无限可能”。',
          address: '6.2A51',
          collect: true
        }*/
      ],
      productData: [
        /*{
          title: 'PET阻燃绑带',
          content: '产品以塑代钢，进一步晚上新能源汽车轻量化、低能耗、绿色环保、增强电池模组的安全性，以便以便产品以塑代钢，进一步晚上新能源汽车轻量化、低能耗、绿色环保、增强电池模组的安全性，产品整体性价比突出。',
          tags: ['#轻量化', '#[2024国际橡塑展]', '专精特新'],
          address: '6.2A51',
          collect: false
        },
        {
          title: 'PET阻燃绑带',
          content: '产品以塑代钢，进一步晚上新能源汽车轻量化、低能耗、绿色环保、增强电池模组的安全性，以便以便产品以塑代钢，进一步晚上新能源汽车轻量化、低能耗、绿色环保、增强电池模组的安全性，产品整体性价比突出。',
          tags: ['#轻量化', '#[2024国际橡塑展]', '专精特新'],
          address: '6.2A51',
          collect: false
        }*/
      ],
      supplierDataPage: {
        pageSize: 20,
        pageNo: 1,
        total: 0,
      },
      onlineSupplierData: [],
      onlineSupplierDataPage: {
        pageSize: 20,
        pageNo: 1,
        total: 0,
      },
      onlineSupplierLoading: false, // 在线展商列表加载状态
      productDataPage: {
        pageSize: 20,
        pageNo: 1,
        total: 0,
      },
      consultDialogOpen: false,
      inviteContent: "",
      isLogin: false,
      postId: null,
      loading: false,
      productLoading: false, // 产品列表加载状态
      supplierLoading: false, // 供应商列表加载状态
      coverImage: null,
      hotTags: [],       // 热门分类标签
      selectedTags: [],  // 当前选中的标签（支持多选）
      exhibitionHalls: ['E1', 'E2', 'E3', 'E4', 'E5', 'E6', 'E7'], // 馆号列表
      selectedHalls: [], // 当前选中的馆号（支持多选）
      isOnlineExhibitor: false, // 是否筛选在线展商
    };
  },
  created() {
    this.initConfig();
    this.isLogin = localStorage.getItem("token");
    if (this.$route.query.search) {
      this.keyword = this.$route.query.search;
    }
    this.selectedValue = localStorage.getItem("queryKey");
    this.current =
      localStorage.getItem("queryKey") === "供应商"
        ? 2
        : localStorage.getItem("queryKey") === "在线展商"
        ? 3
        : 1;
    // 页面初始化时同时加载三个Tab的数据，保证各标签数量正确显示
    this.getEntriesList();
    this.getCompanyProfilesList();
    this.getOnlineExhibitorList();
    this.getHotTags();
  },
  watch: {
    '$language'() {
      this.getHotTags();
      if (this.selectedValue === "产品") {
        this.getEntriesList();
      } else if (this.selectedValue === "在线展商") {
        this.getOnlineExhibitorList();
      }
    },
    "$route.query": {
      handler() {
        this.keyword = this.$route.query.search;
        // 关键词变化时同时刷新三个Tab，保证各标签数量正确
        this.productDataPage = {
          pageSize: 10,
          pageNo: 1,
          total: 0,
        };
        this.supplierDataPage = {
          pageSize: 10,
          pageNo: 1,
          total: 0,
        };
        this.onlineSupplierDataPage = {
          pageSize: 20,
          pageNo: 1,
          total: 0,
        };
        this.$nextTick(() => {
          this.getEntriesList();
          this.getCompanyProfilesList();
          this.getOnlineExhibitorList();
        });
      },
      deep: true,
    },
  },
  methods: {
    getTextByLanguage(primaryText, fallbackText) {
      if (primaryText && primaryText.trim()) {
        return primaryText;
      }
      return fallbackText || '';
    },
    // 解析展位面积字符串为数字，支持 '50'、'50㎡'、'50 平方米'、'50 sq.m' 等格式
    parseBoothArea(value) {
      if (!value) return 0;
      const numericStr = String(value).replace(/[^0-9.]/g, '');
      const num = parseFloat(numericStr);
      return isNaN(num) ? 0 : num;
    },
    // 根据专精特新企业类型(cxif)返回对应类型名称，无类型时返回空字符串
    getCxifLabel(cxif) {
      const map = {
        national_single_champion: this.$t("h.Company.nationalSingleChampion"),
        national_giant: this.$t("h.Company.nationalGiant"),
        specialized_sme: this.$t("h.Company.specializedSme"),
        innovative_sme: this.$t("h.Company.innovativeSme"),
      };
      return (cxif && map[cxif]) || "";
    },
    handleCategoryClick(tag) {
      const tagCode = tag.code;
      const index = this.selectedTags.indexOf(tagCode);
      
      if (index > -1) {
        this.selectedTags.splice(index, 1);
      } else {
        this.selectedTags.push(tagCode);
      }
      
      this.current = 1;
      this.selectedValue = "产品";

      this.productDataPage = {
        pageSize: 10,
        pageNo: 1,
        total: 0,
      };
      
      // 只加载当前Tab页的数据
      this.$nextTick(() => {
        this.getEntriesList();
      });
    },
    handleClassifySearch(classifyCode) {
      this.searchType = 'classify';
      this.keyword = classifyCode;
      this.searchBtn();
    },
    async getHotTags() {
      try {
        const res = await this.$axios.get('/app/info/hotClassifyTags', {
          params: { language: this.$language }
        });
        if (res.data.success) {
          this.hotTags = res.data.result;
        }
      } catch (error) {
        console.error('获取热门标签失败:', error);
      }
    },
    initConfig() {
      let imageCode =
        this.$language === "ZH"
          ? "POSTER_COMPANY_IMAGE"
          : "POSTER_COMPANY_IMAGE_EN";
      this.$axios.get(codeConfig + imageCode).then((res) => {
        this.coverImage = res && res.data.success ? res.data.result : null;
      });
    },
    submitBtn() {
      if (!this.inviteContent) {
        this.$message.error(
          this.$t("h.MyConsultation.PleaseEnterWhatYouWantToConsult")
        );
        return false;
      }
      if (this.inviteContent.length > 200) {
        this.$message.error(this.$t("h.MyConsultation.NoMore"));
        return false;
      }
      this.loading = true;
      this.$axios
        .post(addConsultations, {
          title: this.inviteContent,
          type: this.current == 1 ? 3 : 1,
          postId: this.postId,
        })
        .then((res) => {
          if (res.data.success) {
            this.loading = false;
            this.$message.success(res.data.message);
            this.consultDialogOpen = false;
            this.inviteContent = null;
          } else {
            this.loading = false;
            this.$message.error(res.data.message);
          }
        });
    },
    handleShare(data, id) {
      const textArea = document.createElement("textArea");
      textArea.value = window.location.href + "-detail?id=" + id;
      //添加到dom节点中
      textArea.style.width = 0;
      textArea.style.position = "fixed";
      textArea.style.left = "-999px";
      textArea.style.top = "10px";
      textArea.setAttribute("readonly", "readonly");
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      // 移除元素
      document.body.removeChild(textArea);
      this.$message.success(this.$t("h.custom.SharedURLCopied"));
    },
    handleTagSearch(keyword) {
      const tagName = this.$language === 'ZH' ? tag.name : tag.nameEn;
      this.keyword = keyword;
      this.$nextTick(() => {
        if (this.current === 1) {
          this.getEntriesList();
        } else {
          this.getCompanyProfilesList();
        }
        //return false;
      });
    },
    handleAddCollection(item) {
      if (this.isLogin) {
        if (item.isCollect) {
          this.$message.warning(this.$t("h.custom.YouHaveAlreadyCollected"));
          return false;
        }
        this.$axios
          .post(addCollection, {
            collectType: this.current,
            linkId: item.id,
            title: item[this.current == 2 ? "companyNameCn" : "titleCn"],
            coverImage: item[this.current == 2 ? "logoUrl" : "imageUrl"],
          })
          .then((res) => {
            if (res.data.success) {
              item.isCollect = true;
              this.$message.success(res.data.message);
            } else {
              this.$message.error(res.data.message);
            }
          });
      } else {
        this.$message.warning(this.$t("h.custom.PleaseLogin"));
      }
    },
    handleSelectChange() {
      if (this.selectedValue === "产品") {
        this.current = 1;
      } else if (this.selectedValue === "在线展商") {
        this.current = 3;
      } else {
        this.current = 2;
      }
      this.selectedTags = []; // 清除所有选中的标签
    },
    handleProductPageChange() {
      this.getEntriesList();
    },
    handleSupplierPageChange() {
      this.getCompanyProfilesList();
    },
    handleOnlineSupplierPageChange() {
      this.getOnlineExhibitorList();
    },
    getList(keyword) {
      // 只加载当前Tab页的数据
      if (this.current === 1) {
        this.getEntriesList();
      } else if (this.current === 3) {
        this.getOnlineExhibitorList();
      } else {
        this.getCompanyProfilesList();
      }
    },
    getEntriesList() {
      // 防止重复请求
      if (this.productLoading) return;
      this.productLoading = true;
      
      const params = {
        pageSize: this.productDataPage.pageSize,
        pageNo: this.productDataPage.pageNo,
        language: this.$language,
        sortBy: 'area'
      };

      if (this.selectedTags.length > 0) {
        params.searchType = 'classify';
        params.keyword = this.selectedTags.join(',');
      } else if (this.keyword) {
        params.keyword = this.keyword;
      }

      // 馆号筛选参数（如果有）
      if (this.selectedHalls.length > 0) {
        params.hallNos = this.selectedHalls.join(',');
      }

      // 在线展商筛选
      if (this.isOnlineExhibitor) {
        params.countyType = '5';
      }

      this.$axios.get(getEntriesList, { params })
          .then((res) => {
            if (res.data.success) {
              let records = res.data.result.records || [];
              // 过滤掉审核未通过(3)和待审核(1)的产品，只显示审核通过(2)的
              records = records.filter(item => String(item.status) === '2');
              // 中文页面：过滤掉中文标题和内容都为空的产品
              if (this.$language === 'ZH') {
                records = records.filter(item => {
                  const titleCn = (item.titleCn || '').trim();
                  const briefCn = (item.briefCn || '').trim();
                  const descriptionCn = (item.descriptionCn || '').trim();
                  return titleCn || briefCn || descriptionCn;
                });
              }
              // 根据展商面积从大到小排序（取关联展商的 boothRange 字段）
              records.sort((a, b) => {
                const areaA = this.parseBoothArea(a.companyProfiles && a.companyProfiles.boothRange);
                const areaB = this.parseBoothArea(b.companyProfiles && b.companyProfiles.boothRange);
                return areaB - areaA;
              });
              this.productData = records;
              this.productDataPage.total = res.data.result.total;
            } else {
              this.$message.error(res.data.message);
            }
          })
          .finally(() => {
            this.productLoading = false;
          });
    },
    getCompanyProfilesList() {
      // 防止重复请求
      if (this.supplierLoading) return;
      this.supplierLoading = true;
      
      const params = {
        keyword: this.keyword,
        pageSize: this.supplierDataPage.pageSize,
        pageNo: this.supplierDataPage.pageNo,
        sortBy: 'area'
      };
      
      // 如果有选中的分类标签，将其作为分类搜索参数传递（通过产品分类关联展商）
      if (this.selectedTags.length > 0) {
        params.keyword = this.selectedTags.join(',');
        params.searchType = 'classify';
      } else if (this.keyword && this.current === 1) {
        // 如果是产品搜索且有关键词，通过产品关键词关联展商
        params.searchType = 'product';
      }
      
      // 馆号筛选参数（如果有）
      if (this.selectedHalls.length > 0) {
        params.hallNos = this.selectedHalls.join(',');
      }
      
      // 在线展商筛选
      if (this.isOnlineExhibitor) {
        params.countyType = '5';
      }
      
      this.$axios
        .get(getCompanyProfilesList, { params })
        .then((res) => {
          if (res.data.success) {
            this.supplierData = res.data.result.records;
            this.supplierDataPage.total = res.data.result.total;
          } else {
            this.$message.error(res.data.message);
          }
        })
        .finally(() => {
          this.supplierLoading = false;
        });
    },
    getOnlineExhibitorList() {
      // 防止重复请求
      if (this.onlineSupplierLoading) return;
      this.onlineSupplierLoading = true;

      const params = {
        keyword: this.keyword,
        pageSize: this.onlineSupplierDataPage.pageSize,
        pageNo: this.onlineSupplierDataPage.pageNo,
        sortBy: 'area',
        countyType: '5',
      };

      this.$axios
        .get(getCompanyProfilesList, { params })
        .then((res) => {
          if (res.data.success) {
            this.onlineSupplierData = res.data.result.records;
            this.onlineSupplierDataPage.total = res.data.result.total;
          } else {
            this.$message.error(res.data.message);
          }
        })
        .finally(() => {
          this.onlineSupplierLoading = false;
        });
    },
    tabChange(current) {
      this.current = current;
      if (this.current === 1) {
        this.selectedValue = "产品";
      } else if (this.current === 3) {
        this.selectedValue = "在线展商";
      } else {
        this.selectedValue = "供应商";
      }

      if (this.current === 1 && !this.productData.length) {
        this.getEntriesList();
      }
      if (this.current === 2 && !this.supplierData.length) {
        this.getCompanyProfilesList();
      }
      if (this.current === 3 && !this.onlineSupplierData.length) {
        this.getOnlineExhibitorList();
      }
    },
    consultBtn(id) {
      if (this.isLogin) {
        this.postId = id;
        this.consultDialogOpen = true;
      } else {
        this.$message.warning(this.$t("h.custom.PleaseLogin"));
      }
    },
    supplierDetailBtn(id) {
      this.$router.push({
        path: "/product/supplier-detail",
        query: {
          id,
        },
      });
    },
    productDetailBtn(id) {
      this.$router.push({
        path: "/product/product-detail",
        query: {
          id,
        },
      });
    },
    searchBtn() {
      this.selectedTags = []; // 清除所有选中的标签
      this.selectedHalls = []; // 清除所有选中的馆号
      this.isOnlineExhibitor = false; // 清除在线展商筛选

      this.$router.push({
        path: "/product/supplier",
        query: {
          search: this.keyword,
        },
      });

      if (this.selectedValue === "产品") {
        this.productDataPage = {
          pageSize: 10,
          pageNo: 1,
          total: 0,
        };
        this.$nextTick(() => {
          this.getEntriesList();
        });
      } else if (this.selectedValue === "在线展商") {
        this.onlineSupplierDataPage = {
          pageSize: 20,
          pageNo: 1,
          total: 0,
        };
        this.$nextTick(() => {
          this.getOnlineExhibitorList();
        });
      } else {
        this.supplierDataPage = {
          pageSize: 10,
          pageNo: 1,
          total: 0,
        };
        this.$nextTick(() => {
          this.getCompanyProfilesList();
        });
      }

    },
    
    handleHallSelect(hall) {
      const index = this.selectedHalls.indexOf(hall);
      
      if (index > -1) {
        this.selectedHalls.splice(index, 1);
      } else {
        this.selectedHalls.push(hall);
        // 选择馆号时清除在线展商筛选
        this.isOnlineExhibitor = false;
      }
      
      // 重置分页
      this.productDataPage.pageNo = 1;
      this.productDataPage.total = 0;
      this.supplierDataPage.pageNo = 1;
      this.supplierDataPage.total = 0;
      
      // 优先显示供应商列表，但不切换Tab - 让用户决定看哪个
      // 注释掉自动切换，保持当前Tab
      // if (this.selectedHalls.length > 0) {
      //   this.selectedValue = "供应商";
      //   this.current = 2;
      // }
      
      // 加载两个Tab页的数据
      this.$nextTick(() => {
        this.getEntriesList();
        this.getCompanyProfilesList();
      });
    },
    handleOnlineExhibitorSelect() {
      this.isOnlineExhibitor = !this.isOnlineExhibitor;
      // 选择在线展商时清除馆号筛选
      if (this.isOnlineExhibitor) {
        this.selectedHalls = [];
      }
      // 重置分页
      this.productDataPage.pageNo = 1;
      this.productDataPage.total = 0;
      this.supplierDataPage.pageNo = 1;
      this.supplierDataPage.total = 0;
      // 加载两个Tab页的数据
      this.$nextTick(() => {
        this.getEntriesList();
        this.getCompanyProfilesList();
      });
    },
    resetFilters() {
      this.selectedTags = [];
      this.selectedHalls = [];
      this.isOnlineExhibitor = false;
      this.keyword = null;
      this.searchType = null;
      
      this.productDataPage = {
        pageSize: 10,
        pageNo: 1,
        total: 0,
      };
      this.supplierDataPage = {
        pageSize: 10,
        pageNo: 1,
        total: 0,
      };
      this.onlineSupplierDataPage = {
        pageSize: 20,
        pageNo: 1,
        total: 0,
      };
      
      // 加载两个Tab页的数据
      this.$nextTick(() => {
        this.getEntriesList();
        this.getCompanyProfilesList();
        this.getOnlineExhibitorList();
      });
    },
  },
};
</script>

<style scoped lang="scss">
.myPagination {
  ::v-deep .ant-pagination-item-active {
    border-color: #d7000F;
    background-color: #d7000F;

    a {
      color: #fff;
    }
  }
}

a {
  color: #3da5ff;
  text-decoration: none;
  transition: color 0.3s ease; /* 添加颜色过渡效果 */
}

a:hover {
  color: #d7000F;
  text-decoration: underline;
}

a:visited {
  color: #3da5ff;
}

a:active {
  color: yellow;
}

::v-deep .ant-select-selection {
  height: 58px;
  border-radius: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .ant-select-arrow {
  right: 20px;
}

::v-deep .ant-modal-header {
  border-bottom: none;
}

::v-deep .ant-modal-footer {
  border-top: none;
}

::v-deep .ant-modal-body {
  padding: 0 24px;
}

.filter-card {
  background: linear-gradient(145deg, #ffffff 0%, #fafafa 100%);
  border-radius: 12px;
  padding: 20px;
  box-shadow: 
    0 4px 15px rgba(0, 0, 0, 0.08),
    0 1px 3px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.8);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 
      0 8px 25px rgba(0, 0, 0, 0.12),
      0 2px 6px rgba(0, 0, 0, 0.06);
  }
}

.filter-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
}

.filter-title {
  display: flex;
  align-items: center;
  gap: 8px;
  
  h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #2c3e50;
    letter-spacing: 0.5px;
  }
}

.title-icon {
  font-size: 14px;
  color: #d7000F;
}

.reset-btn {
  font-size: 12px;
  padding: 4px 12px;
  border-radius: 16px;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%);
  border: 1px solid #d9d9d9;
  color: #666;
  transition: all 0.2s ease;
  
  &:hover {
    background: linear-gradient(135deg, #e8eaed 0%, #d4d8dc 100%);
    border-color: #c0c0c0;
    color: #333;
    transform: scale(1.02);
  }
}

.filter-content {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.filter-tag {
  display: inline-flex;
  align-items: center;
  padding: 6px 14px;
  background: linear-gradient(135deg, #f0f7ff 0%, #e6f0fa 100%);
  border-radius: 20px;
  cursor: pointer;
  color: #3386f1;
  font-size: 13px;
  font-weight: 400;
  border: 1px solid #d4e6f7;
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 20px;
    background: linear-gradient(135deg, rgba(215, 0, 15, 0.05) 0%, rgba(215, 0, 15, 0.02) 100%);
    opacity: 0;
    transition: opacity 0.25s ease;
  }
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(51, 134, 241, 0.15);
    border-color: #99c7f7;
    
    &::before {
      opacity: 1;
    }
  }
  
  &.active {
    background: linear-gradient(135deg, #d7000F 0%, #b8000d 100%);
    color: #ffffff;
    border-color: #d7000F;
    box-shadow: 
      0 4px 15px rgba(215, 0, 15, 0.3),
      inset 0 1px 0 rgba(255, 255, 255, 0.2);
    
    &::before {
      opacity: 0;
    }
    
    &:hover {
      transform: translateY(-2px) scale(1.02);
      box-shadow: 
        0 6px 20px rgba(215, 0, 15, 0.4),
        inset 0 1px 0 rgba(255, 255, 255, 0.3);
    }
  }
}

.list-card {
  background: linear-gradient(145deg, #ffffff 0%, #fafafa 100%);
  border-radius: 12px;
  border: 1px solid #e8e8e8;
  margin-top: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 
    0 2px 8px rgba(0, 0, 0, 0.06),
    0 1px 2px rgba(0, 0, 0, 0.04);
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 
      0 8px 25px rgba(0, 0, 0, 0.12),
      0 2px 8px rgba(0, 0, 0, 0.08);
    border-color: #d7000F;
  }
}

.card-header {
  background: linear-gradient(135deg, #f8f9fa 0%, #f0f0f0 100%);
  padding: 16px 20px;
  border-bottom: 1px solid #e8e8e8;
  border-radius: 12px 12px 0 0;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
  letter-spacing: 0.3px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.cxif-badge {
  background: #FFECE4;
  border-radius: 3px;
  font-size: 12px;
  font-weight: 400;
  color: #FF9419;
  height: 22px;
  line-height: 22px;
  padding: 0 10px;
  flex-shrink: 0;
}

.card-content {
  padding: 16px 20px;
}

.card-description {
  font-size: 14px;
  color: #5a6c7d;
  line-height: 24px;
  margin-bottom: 12px;
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  height: 72px;
}

.card-tags {
  margin-bottom: 12px;
}

.card-tag {
  display: inline-block;
  padding: 3px 10px;
  background: linear-gradient(135deg, #e8f4fd 0%, #d4eafd 100%);
  border-radius: 4px;
  font-size: 12px;
  color: #3386f1;
  margin-right: 8px;
  margin-bottom: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid #b8d8f5;
  
  &:hover {
    background: linear-gradient(135deg, #3386f1 0%, #1e6dd6 100%);
    color: #ffffff;
    border-color: #3386f1;
    transform: translateY(-1px);
  }
}

.card-footer {
  padding: 16px 20px;
  border-top: 1px solid #f0f0f0;
  background: #fafafa;
  border-radius: 0 0 12px 12px;
}

.booth-info {
  display: flex;
  align-items: center;
  padding: 8px 14px;
  background: #f5f7fa;
  border-radius: 8px;
  margin-bottom: 14px;
  width: fit-content;
  
  img {
    width: 16px;
    height: 18px;
    margin-right: 8px;
    opacity: 0.7;
  }
  
  a {
    font-size: 13px;
    color: #5a6c7d;
    text-decoration: none;
    
    &:hover {
      color: #d7000F;
      text-decoration: underline;
    }
  }
}

.card-actions {
  display: flex;
  gap: 16px;
}

.action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 90px;
  height: 36px;
  padding: 0 14px;
  background: #ffffff;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  font-size: 13px;
  color: #5a6c7d;
  transition: all 0.25s ease;
  
  span {
    padding-left: 6px;
  }
  
  &:hover {
    background: linear-gradient(135deg, #f8f9fa 0%, #f0f0f0 100%);
    border-color: #d7000F;
    color: #d7000F;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(215, 0, 15, 0.15);
  }
}

.product-card {
  .card-content {
    padding: 0;
    margin-top: 12px;
  }
}

.product-content {
  display: flex;
  padding: 16px 20px;
}

.product-image {
  width: 280px;
  height: 180px;
  object-fit: cover;
  border-radius: 8px;
  margin-right: 20px;
  flex-shrink: 0;
}

.product-right-section {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.product-info {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.product-desc {
  height: 96px;
  -webkit-line-clamp: 4;
}

.company-name {
  font-weight: 600;
  color: #2c3e50;
  font-size: 14px;
  margin-top: 8px;
}

.product-card .card-actions {
  margin-top: auto;
  justify-content: flex-end;
}
</style>
